module.exports = __webpack_public_path__ + "static/media/caret_right.b4176fae.svg";